import { IS_DEV } from "@/data/constants";
import { TUserPlanData } from "@/types/plan-data";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "reactfire";
import { PosthogService } from "../index";
import { USER_PLAN_QUERY_KEY } from "@/components/Root/hooks/useUserPlanData";

export const usePostHog = () => {
  const auth = useAuth();
  const qc = useQueryClient();
  const userEmail = auth.currentUser?.email;

  const planData = qc.getQueryData<TUserPlanData>([USER_PLAN_QUERY_KEY]);

  const defaultOptions = {
    platform: "website",
    location: window.location.pathname,
    email: auth.currentUser ? userEmail : "not signed",
    planName: auth.currentUser ? planData?.planName : null,
    planInterval: auth.currentUser ? planData?.recurring?.interval : null,
  };

  const registerPostHog = (eventName: string, options?: any) => {
    if (IS_DEV) return;
    PosthogService.capture(eventName, { ...defaultOptions, ...options });
  };

  return { registerPostHog };
};

export default usePostHog;
